import { request } from '@umijs/max';
import { API } from '@/types/admin';
import { stringify } from 'qs';

import { ACCESS_TOKEN_KEY } from '@/utils/constants';
import { API_BASE_URL } from './common';
import adminRoutes from '@config/adminRoutes';


/*～～～～～～～～～～～～～～～～～～～～部门管理～～～～～～～～～～～～～～～～～～～～*/
//获取部门列表

export async function getDepartmentList(params: API.DepartmentListParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/dept/list?${stringify(params)}`, {
    method: 'GET',
  });
}

// 获取部门树形列表 
export async function getDeptTree(params: API.DepartmentTreeParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/dept/tree?${stringify(params)}`, {
    method: 'GET',
  });
}

// 新建部门
export async function createDepartment(params: API.createDepartmentParams,) {
    return request<API.Result>(`${API_BASE_URL}/api/system/dept/create`, {
      method: 'POST',
      data: params,
    });
}

// 更新部门
export async function updateDepartment(params: API.createDepartmentParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/dept/update`, {
    method: 'PUT',
    data: params,
  });
}

//删除部门/system/dept/delete
export async function deleteDepartment(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/dept/delete?id=${params}`, {
    method: 'DELETE',
  });
}


/*～～～～～～～～～～～～～～～～～～～～用户管理～～～～～～～～～～～～～～～～～～～～*/
// 获取用户分页列表
export async function getUserList(params: API.UserListParams) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/page?${stringify(params)}`, {
    method: 'GET',
  });
}

// 获取用户列表-无分页
export async function getUserListNoPagination(params: API.UserListParams) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/simpleList?${stringify(params)}`, {
    method: 'GET',
  });
}


// 
/**
 * 获取租户下的用户列表
 * @param params - 请求参数tenantId: number, queryType: 'annotator' | 'reviewer'
*/
export async function getUserListByTenant(params:any) {
  return request<API.Result>(`${API_BASE_URL}/api/biz/task/getSimpleUserListByTenant?${stringify(params)}`, {
    method: 'GET',
  });
}


// 新建用户
export async function createUser(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/create`, {
    method: 'POST',
    data: params,
  });
}

// 更新用户
export async function updateUser(params: API.CreateUserParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/update`, {
    method: 'PUT',
    data: params,
  });
}

// 更新用户状态
export async function updateUserStatus(params: API.UserUpdateStatusParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/updateStatus`, {
    method: 'PUT',
    data: params,
  });
}


/**
 * 移除用户
 * @param params - ids=1,2,3&tenantId=33
*/
export async function removeUser(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/remove?${stringify(params)}`, {
    method: 'POST',
  });
}


/*～～～～～～～～～～～～～～～～～～～～岗位管理～～～～～～～～～～～～～～～～～～～～*/

// 获取岗位列表
export async function getPositionList(params: API.CreatPositionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/post/page?${stringify(params)}`, {
    method: 'GET',
  });
}


// 新建岗位
export async function createPosition(params: API.createPosituiionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/post/create`, {
    method: 'POST',
    data: params,
  });
}

// 修改岗位
export async function updatePosition(params: API.createPosituiionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/post/update`, {
    method: 'PUT',
    data: params,
  });
}

// 删除岗位
export async function deletePosition(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/post/delete?id=${params}`, {
    method: 'DELETE',
  });
}

/*～～～～～～～～～～～～～～～～～～～～租户管理～～～～～～～～～～～～～～～～～～～～*/

// 获取租户列表
export async function getTenantList(params:any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/page?${stringify(params)}`, {
    method: 'GET',
  });
}

// 获取租户全部列表
export async function getTenantListAll() {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/list`, {
    method: 'GET',
  });
}


// 新建租户
export async function createTenant(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/create`, {
    method: 'POST',
    data: params,
  });
}

// 更新租户
export async function updateTenant(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/update`, {
    method: 'PUT',
    data: params,
  });
}

// 加入租户
export async function joinTenant(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/join`, {
    method: 'POST',
    data: params,
  });
}

// 加入租户
export async function setUserTenant(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/setUserTenant?${stringify(params)}`, {
    method: 'POST',
  });
}

// 获取某租户信息
export async function getTenant(params:any) {  
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/get?id=${params}`, {
    method: 'GET',
  });
}

// 获取某租户下所有用户
export async function getTenantUserList(params:any) {  
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/userList?id=${params}`, {
    method: 'GET',
  });
}

// 删除租户
export async function deleteTenant(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/delete?ids=${params}`, {
    method: 'DELETE',
  });
}


/**
 * 禁用租户
 * @param params - 请求参数 ids:'1,2,3'
 * */ 
export async function disableTenant(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/disable?ids=${params}`, {
    method: 'POST',
    // data: params,
  });
}

/**
 * 取消禁用租户
 * @param params - 请求参数 ids:'1,2,3'
 * */ 
export async function enableTenant(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/enableTenant?ids=${params}`, {
    method: 'POST',
    // data: params,
  });
}


/**
 * 修改邀请码
 * @param params tanantId: number, joinCode: string,openDays: number
 * @returns 
 */

export async function updateJoinCode(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/tenant/updateJoinCode`, {
    method: 'PUT',
    data: params,
  });
}
/*～～～～～～～～～～～～～～～～～～～～角色管理～～～～～～～～～～～～～～～～～～～～*/

// 获取租户可用角色列表
export async function getTenantRoleList(params:any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/role/getTenantRoleList?tenantId=${params}`, {
    method: 'GET',
  });
}

// 获取角色列表
export async function fetchRoleList(params: API.any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/role/list-all-simple?${stringify(params)}`, {
    method: 'GET',
  });
}


/*～～～～～～～～～～～～～～～～～～～～定时任务～～～～～～～～～～～～～～～～～～～～*/

export async function fetchJob(params: API.any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/job/page?${stringify(params)}`, {
    method: 'GET',
  });
}
/**
 * 更新任务状态
 * @param params  id: number, status: number
 * @returns 
 */
export async function UpdateJobStatus(params: API.any) {
    return request<API.Result>(`${API_BASE_URL}/api/system/job/update-status?${stringify(params)}`, {
    method: 'PUT',
  });
}

/**
 * 删除任务
 * @param params  id: number
 * @returns 
 */
export async function deleteJob(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/job/delete?id=${params}`, {
    method: 'DELETE',
  });
}

/**
 * 新增定时任务
 * @param params  任务名称：name (String)
 * @param params  处理器的名字：handlerName (String)
 * @param params  处理器的参数：handlerParam (String)
 * @param params  CRON 表达式：cronExpression (String)
 * @param params  重试次数：retryCount (Integer)
 * @param params  重试间隔：retryInterval (Integer)
 * @param params  监控超时时间：monitorTimeout (Integer)
 * @returns 
 */
export async function createJob(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/job/create`, {
    method: 'POST',
    data: params,
  });
}
/**
 * 修改任务
 * @param params  与新建相同
 * @returns 
 */
export async function updateJob(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/job/update`, {
    method: 'PUT',
    data: params,
  });
}

/**
 * 开启任务
 * @param params  id: number
 * @returns 
 */

export async function triggerJob(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/job/trigger?${stringify(params)}`, {
    method: 'PUT',
  });
}

/**
 * 获取定时任务详情
 * @param params  id: number
 * @returns 
 */
export async function getJobDetail(id: API.any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/job/get?id=${id}`, {
    method: 'GET',
  });
}

/**
 * 获取定时任务的下 N 次执行时间
 * @param params  id: number
 * @returns 
 */
export async function fetchNextTimes(id: API.any) {
  console.log('Fetching next times for job ID:', id);
  return request<API.Result>(`${API_BASE_URL}/api/system/job/get_next_times?id=${id}`, {
    method: 'GET',
  });
}

/*～～～～～～～～～～～～～～～～～～～～定时任务日志～～～～～～～～～～～～～～～～～～～～*/
/**
 * 获取定时任务日志分页
 * @param params  id: number，handlerName，beginTime，endTime，status，pageNo，pageSize
 * @returns 
 */
export async function fetchJobLog(params: API.any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/joblog/page?${stringify(params)}`, {
    method: 'GET',
  });
}

/**
 * 获取日志详情
 * @param params  id: number
 * @returns 
 */
export async function getJobLogDetail(id: number) {
  return request<API.Result>(`${API_BASE_URL}/api/system/joblog/get?id=${id}`, {
    method: 'GET',
  });
}


/*～～～～～～～～～～～～～～～～～～～～订单～～～～～～～～～～～～～～～～～～～～*/

// 获取产品列表
export async function getProductList(params: object,) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/product/spu/page?${stringify(params)}`, {
    method: 'GET',
  });
}

/**
 * 获取订单
 * @param params  tenantId (Integer)
 * @param params  remark(String)
 * @param params  items: [{"skuId": (Integer),"count": (Integer)}]
 * @returns 
 */
export async function createOrder(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/order/create`, {
    method: 'POST',
    data: params,
  });
}

// 获取支付详情
export async function fetchOrderDetail(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/order/get-detail?${stringify(params)}`, {
    method: 'GET',
  });
}

// 获取付款链接
export async function prepayOrder(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/pay/order/prepay?${stringify(params)}`, {
    method: 'POST',
  });
}

// 轮询订单支付状态
export async function queryOrderStatus(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/pay/order/query?${stringify(params)}`, {
    method: 'GET',
  });
}

// 获取订单详情
export async function getOrderDetail(params: object) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/order/page?${stringify(params)}`, {
    method: 'GET',
  });
}


/**
 * 取消订单
 * @param params  orderId (Integer)
 * @returns 
 */
export async function cancelOrder(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/order/cancel?${stringify(params)}`, {
    method: 'POST',
  });
}

/**
 * 删除订单
 * @param params  orderId (Integer)
 * @returns 
 */
export async function deleteOrder(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/mall/order/delete?${stringify(params)}`, {
    method: 'POST',
  });
}


/*～～～～～～～～～～～～～～～～在线用户～～～～～～～～～～～～～～～～～～～～～～～～～～*/

 // 获取在线用户列表
export async function fetchOnlineUserList(params: object,) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/online/page?${stringify(params)}`, {
    method: 'GET',
  });
}

// 踢出用户

export async function forceLogout(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/system/user/forceLogout?${stringify(params)}`, {
    method: 'POST',
  });
}

/*～～～～～～～～～～～～～～～～AI算法-分类～～～～～～～～～～～～～～～～～～～～～～～～～～*/

// 获取分类-aimodal文件
// 获取所有分类
export async function fetchAllCategory(params: object) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/getAllGenre?${stringify(params)}`, {
    method: 'GET',
  });
}


// 新建分类
export async function createAICategory(params: any,) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/createGenre`, {
    method: 'POST',
    data: params,
  });
}

// 更新分类
export async function updateAICategory(params: API.createPosituiionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/updateGenre`, {
    method: 'PUT',
    data: params,
  });
}

// 删除分类
export async function deleteAICategory(params: API.createPosituiionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/deleteGenre?ids=${params}`,{
    method: 'DELETE',
  });
}


// 获取算法列表-分页
export async function fetchAlgorithmList(params: object) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/pageAlgorithm?${stringify(params)}`, {
    method: 'GET',
  });
}

// 获取所有算法
export async function fetchAllAlgorithmList(params: object) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/listAlgorithm?${stringify(params)}`, {
    method: 'GET',
  });
}

// 新建算法
export async function createAIAlgorithm(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/createAlgorithm`, {
    method: 'POST',
    data: params,
  });
}
// 更新算法
export async function updateAIAlgorithm(params: API.createPosituiionParams) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/updateAlgorithm`, {
    method: 'PUT',
    data: params,
  });
}

// 删除算法
export async function deleteAIAlgorithm(params: API.createPosituiionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/deleteAlgorithm?ids=${params}`,{
    method: 'DELETE',
  });
}

// 获取算法包列表-分页
export async function fetchAlgorithmPackage(params: object) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/pageAlgorithmPackage?${stringify(params)}`, {
    method: 'GET',
  });
}


// 新建算法包
export async function createAIAlgorithmPackage(params: any) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/createAlgorithmPackage`, {
    method: 'POST',
    data: params,
  });
}
// 更新算法包
export async function updateAIAlgorithmPackage(params: API.createPosituiionParams) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/updateAlgorithmPackage`, {
    method: 'PUT',
    data: params,
  });
}

// 删除算法包
export async function deleteAIAlgorithmPackage(params: API.createPosituiionParams,) {
  return request<API.Result>(`${API_BASE_URL}/api/annotation/algorithm/deleteAlgorithmPackage?ids=${params}`,{
    method: 'DELETE',
  });
}

// 租户统计
export async function fetchTenantStatistics(params: object) {
  return request<API.Result>(`${API_BASE_URL}/api/biz/tenant/statistic?${stringify(params)}`, {
    method: 'GET',
  });
}

/*～～～～～～～～～～～～～～～～～～～～日志管理～～～～～～～～～～～～～～～～～～～～*/
/**
 * 获取任务日志分页
 * @param params 
 * @returns 
 */
export async function fetchTaskLog(params: API.any) {
  return request<API.Result>(`${API_BASE_URL}/api/biz/task/log/page?${stringify(params)}`, {
    method: 'GET',
  });
}

/*～～～～～～～～～～～～～～～～～～～～导入用户～～～～～～～～～～～～～～～～～～～～*/
/**
 * 上传导入用户
 * @param params 
 * @returns 
 */
export async function batchImportUser(params: any) {
    const formData = new FormData();
    const { file, tenantId } = params;
    formData.append('tenantId', tenantId);
    formData.append('file', file);
    // 获取 token
    const token = sessionStorage.getItem(ACCESS_TOKEN_KEY) || localStorage.getItem(ACCESS_TOKEN_KEY);
  
    try {
      const response = await fetch(`${API_BASE_URL}/api/system/user/batchImportUser`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`, // 请求头添加 Authorization 
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
}